export const metricSettings = {
  "out_percentage_housed":{
    "analysisMesh": false,
    "units": "%",
    "label": "housed",
    "model": true,
    "description": "Locals and newcomers with housing.",
    "starRating": 0,
    "starRatingArray": [],
    "data": [],
    "prettyValue": 0
  },
  "out_percentage_employed":{
    "analysisMesh": false,
    "units": "%",
    "label": "employed",
    "model": false,
    "description": "Locals and newcomers with jobs.",
    "starRating": 0,
    "starRatingArray": [],
    "data": [],
    "prettyValue": 0
  },
  "out_commercial_access":{
    "analysisMesh": true,
    "dataLabel":"commercial_access",
    "colorRamp":[
      "#b5b5b5",
      "#5cb0e5"
    ],
    "min":0,
    "max":1,
    "ticks":[
      "poor",
      "good",
      "excellent"
    ],
    "units": "%",
    "label": "within a 10-min walk of commercial",
    "model": false,
    "description": "Residents with access to commercial activity within a 10-min walk.",
    "starRating": 0,
    "starRatingArray": [],
    "data": [],
    "prettyValue": 0
  },
  "out_energy_independence":{
    "analysisMesh": false,
    "units": "%",
    "label": "energy independent buildings",
    "model": false,
    "description": "Buildings that can depend on energy generated via renewable sources.",
    "starRating": 0,
    "starRatingArray": [],
    "data": [],
    "prettyValue": 0
  },
  "out_green_access":{
    "analysisMesh": true,
    "dataLabel": "green_access",
    "colorRamp":[
      "#fdc89d",
      "#fdfc9d",
      "#4dff88"
    ],
    "min":0,
    "max":1,
    "ticks":[
      "poor",
      "good",
      "excellent"
    ],
    "units": "%",
    "label": "within a 10-min walk of public space",
    "model": false,
    "description": "Residents with access to green space within a 10-min walk.",
    "starRating": 0,
    "starRatingArray": [],
    "data": [],
    "prettyValue": 0
  }
}